import { inject } from 'vue';
import { notify as notifyInstance } from '@/plugins/vue-notification.ts';

/**
 * Composable to use notifications in Composition API components.
 */
export function useNotify(): { notify: typeof notifyInstance } {
    const injectedNotify = inject<typeof notifyInstance | null>('notify', null);

    return { notify: injectedNotify || notifyInstance };
}
